export const INVALID_STR_REGEX = /^[^%*@#!^~'"\\<>|]+$/;

export const ZIP_CODE_REGEX = /^\d{5}-\d{4}$|^\d{5}$/;

export const ENGLISH_ONLY_REGEX = /^[0-9a-zA-Z-]+$/;

export const SWIFT_CODE_REGEX = /^([a-zA-Z]){4}([a-zA-Z]){2}([0-9a-zA-Z]){2}([0-9a-zA-Z]{3})?$/;

export const CREATOR_CODE_REGEX = /^(?![0-9]*$)(?!.*([A-Za-z0-9])\1{2}$)[a-zA-Z0-9]+([_.-]+[a-zA-Z0-9]+)?$/;

export const EMAIL_REGEX = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i;

export const FIND_DOT_MIDDLE_STR_REGEX = /^\.+[^.]*|[^.]*\.+$|(?:\.{2,}|[^.])+(?:\.+$)?/g;
